import { Outlet } from "react-router";
import { I18nProvider } from "@/i18n/I18nProvider";
import { useT } from "@/i18n/useT";
import { LanguageSwitch } from "./LanguageSwitch";

function PicksHeader() {
  const { t } = useT();
  return (
    <header className="flex items-center justify-between border-b border-[var(--border)] px-6 py-3">
      <h1 className="text-[16px] font-[600] text-[var(--fg)]">
        {t("shell.title")}
      </h1>
      <LanguageSwitch />
    </header>
  );
}

export function PicksLayout() {
  return (
    <I18nProvider>
      <PicksHeader />
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>
    </I18nProvider>
  );
}
